import React, { lazy } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import authRoutes from 'routes/globalRoutes/auth';
import myProfileRoutes from 'routes/globalRoutes/myProfile';
import PATH from 'routes/paths';
import { projectIdPattern } from 'routes/replacePatterns';

const Projects = lazy(() =>
  import('components/layout/mainPages/tenantPages/TenantProjectsView')
);

export const ASSIGNED_PROJECTS = {
  component: Projects,
  path: PATH.PROJECT.LIST,
  exact: true,
  isProtected: true,
};

// Redirect /projects/:projectId to tickets (tenant's primary view)
const ProjectRedirectToTickets = () => {
  const { projectId } = useParams();
  return (
    <Redirect
      to={PATH.PROJECT.TICKET.LIST.replace(projectIdPattern, projectId)}
    />
  );
};

const PROJECT_DASHBOARD_REDIRECT = {
  component: ProjectRedirectToTickets,
  path: PATH.PROJECT.ONE,
  exact: true,
  isProtected: true,
};

let routes = [];
const routeFiles = require.context('./', true, /^(?!.\/index|.\/paths).*\.js$/);

routeFiles.keys().forEach((routeFile) => {
  routes = [...routes, ...routeFiles(routeFile).default];
});

const tenantRoutes = [
  ...authRoutes,
  ...myProfileRoutes,
  ...routes,
  ASSIGNED_PROJECTS,
  PROJECT_DASHBOARD_REDIRECT,
];

export default tenantRoutes;
